










































































































import Vue from 'vue';
import store from '@/store';
import WaveOption from '@/components/WaveOption.vue';
import LastWaveEngine from '@/lastwave';
import WaveAction from '@/models/WaveAction';
import Option from '@/models/Option';
import Renderer from '@/models/Renderer';
import DataSource from '@/models/DataSource';
import LoadingStage from '@/models/LoadingStage';
import jQuery from 'jquery';
import StageLoadingBar from '@/components/StageLoadingBar.vue';
import MODULE from '@/models/MODULE';

import LastFm from '@/datasources/lastfm';
import WaveGraph from '@/renderers/d3-wave';
import ImageActions from '@/actions/imageActions.vue';
import OptionActions from '@/actions/optionActions.vue';

const ACTIONS_DIV = '#actions';
const ADVANCED_OPTIONS_DIV = '#advanced-options';
const SVG_WRAPPER_DIV = '#svg-wrapper';

export default Vue.extend({
  components: {
    WaveOption,
    StageLoadingBar,
  },
  data() {
    return {
      dataSources: [new LastFm()],
      renderers: [new WaveGraph()],
      actions: [
        OptionActions,
        ImageActions,
      ],
      dataSourceOptions: [],
      rendererOptions: [],
      mainOptions: [],
      advancedOptionsIcon: '+',
      showFullSvg: false,
      showSvgOptions: false,
      liveActionComponents: [] as Vue[],
      showError: false,
      error: null,
    };
  },
  mounted() {
    let dataSourceOptions: Option[] = this.$data.dataSources[0].getOptions();
    let rendererOptions: Option[] = this.$data.renderers[0].getOptions();
    let mainOptions: Option[] = [];

    // Tag all of the options
    dataSourceOptions.forEach((option) => {
      option.module = MODULE.DATA_SOURCE;
    });
    rendererOptions.forEach((option) => {
      option.module = MODULE.RENDERER;
    });

    // Remove all the options that should be in main options
    mainOptions = dataSourceOptions.filter((option) => option.isImportant);
    mainOptions = mainOptions.concat(rendererOptions.filter((option) => option.isImportant));

    dataSourceOptions = dataSourceOptions.filter((option) => !option.isImportant);
    rendererOptions = rendererOptions.filter((option) => !option.isImportant);

    this.$data.dataSourceOptions = dataSourceOptions;
    this.$data.rendererOptions = rendererOptions;
    this.$data.mainOptions = mainOptions;

    store.commit('showOptions');
    store.commit('hideLoadingBar');
    store.commit('hideActions');
    store.commit('hideVisualization');
  },
  methods: {
    createWave(evnt: any) {
      const engine = new LastWaveEngine();
      const dataSource = this.$data.dataSources[0];
      const dsOptions = store.state.dataSourceOptions;
      const renderer = this.$data.renderers[0];
      const renderOptions = store.state.rendererOptions;

      store.commit('hideOptions');
      store.commit('showLoadingBar');

      engine.CreateWave(dataSource, renderer, dsOptions, renderOptions).then(() => {
        store.commit('hideLoadingBar');
        store.commit('showActions');
        store.commit('showVisualization');
        this.showSvgOptions = true;

        if (!jQuery(ADVANCED_OPTIONS_DIV).is(':visible')) {
          this.showAdvancedOptions();
        }

        // TODO this is definitely not a vue-friendly way of doing this
        // Essentially we need to have a list of actions that get refreshed every time
        // a new wave is created

        // Destroy old actions
        this.liveActionComponents.forEach((component: Vue) => {
          component.$destroy();
        });
        jQuery(ACTIONS_DIV).empty();

        // Add new actions
        this.actions.forEach((action: any) => {
          const newInstance = new action();
          this.liveActionComponents.push(newInstance);
          newInstance.$mount();
          jQuery(ACTIONS_DIV).append(newInstance.$el);
        });
      }).catch((e) => {
        store.commit('log', e);
        this.$data.showError = true;
        this.$data.error = e;
      });
    },
    chooseDataSource: () => {
      return;
    },
    showAdvancedOptions() {
      jQuery(ADVANCED_OPTIONS_DIV).toggle(1000);
      // TODO this should just read from state instead
      this.$data.advancedOptionsIcon = this.$data.advancedOptionsIcon === '+' ? '-' : '+';
    },
    toggleFullSvg() {
      this.$data.showFullSvg = !this.$data.showFullSvg;
    },
    backToOptions() {
      store.commit('showOptions');
      store.commit('hideLoadingBar');
      store.commit('hideActions');
      store.commit('hideVisualization');
    },
  },
  computed: {
    currentStage(): LoadingStage {
      const currentStage: LoadingStage = store.state.stages[store.state.currentStage];
      return currentStage;
    },
    showLoadingBar(): boolean {
      return store.state.showLoadingBar;
    },
    showOptions(): boolean {
      return store.state.showOptions;
    },
    showVisualization(): boolean {
      return store.state.showVisualization;
    },
    showActions(): boolean {
      return store.state.showActions;
    },
  },
});
